<template>
              <div class="banner">
                <div class="bd">
                    <ul class="Fade"
                        style="position: relative; width: 1920px; height: 600px; color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); font-size: 12px; line-height: 18px; margin: 0px; padding: 0px; float: none; inset: 0px; display: block; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none none; text-align: center;">
                        <li v-for="(items,index) in imgArr" :key="index" v-show="items.id===currentIndex" @mouseover="changeInterval(true)" 
         @mouseleave="changeInterval(false)"
                           >
                            <a href="" target=""
                                style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: 1000px; height: auto; font-size: 12px; line-height: 18px; margin: 0px; padding: 0px; position: static; float: none; inset: auto; display: inline; border: 0px none rgb(102, 102, 102); cursor: pointer; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none none; text-align: center;"><img
                                    :src= "items.url"   width=  "1000" height="600" alt="1"
                                    style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: 1920px; height: 600px; font-size: 12px; line-height: 18px; margin: 0px; padding: 0px; position: static; float: none; inset: auto; display: inline; border: 0px none rgb(102, 102, 102); cursor: pointer; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none none; text-align: center;"></a>
                        </li>

                    </ul>
                </div>
                <div class="hd"
                    style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: 1903px; height: 14px; font-size: 12px; line-height: 18px; margin: 0px; padding: 0px; position: absolute; float: none; inset: 526px 0px 60px; display: block; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none disc; text-align: center;">
                    <ul >
                                              <li class="onon" v-for="(item) in imgArr" :key="item.id"
                        @mouseover="changeImg(item.id)"
                        :class="item.id === currentIndex? 'on':'onon'"
                        >
                            </li>
                    </ul>
                </div>
            </div>         
</template>

<script lang="js">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'banner',
  components: {
  },
  data(){
    return{
      currentIndex:0,
      timer:null,
      imgArr:[
        {
          id:0,
          url:require("../assets/upload/banner/one.jpg")
        },
        {
          id:1,
          url:require("../assets/upload/banner/two.jpg")
        },
        {
          id:2,
          url:require("../assets/upload/banner/zhys.jpg")
        },
        {
          id:3,
          url:require("../assets/upload/banner/four.jpg")
        }
      ]
    }
  },
      methods:{
			startInterval(){
				// 事件里定时器应该先清除在设置，防止多次点击直接生成多个定时器
				clearInterval(this.timer);
				this.timer = setInterval(()=>{
					this.currentIndex++;
					if(this.currentIndex > this.imgArr.length-1){
						this.currentIndex = 0
					}
				},3000)
      },
      changeInterval(val){
				if(val){
					clearInterval(this.timer)
				}else{
					this.startInterval()
				}
      },
      changeImg(id){
        this.currentIndex = id
      }
    },
		mounted(){
			this.startInterval()
		}
});
</script>
<style scoped>
.onon {
    color: rgb(102, 102, 102);
    background: none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255);
    width: 14px;
    height: 14px;
    font-size: 12px;
    /* line-height: 999px; */
    margin: 0px 4px;
    /* position: static; */
    /* inset: auto; */
    display: inline-flex;
    justify-content: center;
    border: 0px none rgb(102, 102, 102);
    cursor: pointer;
    overflow: hidden;
    box-sizing: content-box;
    border-radius: 100%;
    text-decoration: none solid rgb(102, 102, 102);


}
         .flip-list-enter-active, .flip-list-leave-active {
             transition: all 1s;
         }
         .flip-list-enter, .flip-list-leave-active {
           opacity: 0;
         }
.on {
    color: rgb(0, 160, 234);
    background: none 0% 0% / auto repeat scroll padding-box border-box rgb(0, 160, 234);
    width: 14px;
    height: 14px;
    font-size: 12px;
    line-height: 999px;
    margin: 0px 4px;
    padding: 0px;
    position: static;
    float: none;
    inset: auto;
    display: inline-block;
    border: 0px none rgb(102, 102, 102);
    cursor: pointer;
    overflow: hidden;
    box-sizing: content-box;
    border-radius: 100%;
    text-decoration: none solid rgb(102, 102, 102);
    list-style: outside none none;
    text-align: center;

}

.headList>li>a {
    color: rgb(102, 102, 102);
    background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);
    width: 84px;
    height: 86px;
    font-size: 14px;
    line-height: 86px;
    margin: 0px;
    padding: 0px;
    position: static;
    float: none;
    inset: auto;
    display: block;
    border: 0px none rgb(102, 102, 102);
    cursor: pointer;
    overflow: visible;
    box-sizing: content-box;
    border-radius: 0px;
    text-decoration: none solid rgb(102, 102, 102);
    list-style: outside none none;
    text-align: left;
}

.headList>li>a:hover {
    color: rgb(0, 160, 234)
}

.headList>li>div>dl>dt>a {
    color: rgb(102, 102, 102);
    background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);
    width: 100%;
    height: auto;
    font-size: 12px;
    line-height: 18px;
    margin: 0px;
    padding: 7px 3px;
    position: static;
    float: none;
    inset: auto;
    display: block;
    border: 0px none rgb(102, 102, 102);
    cursor: pointer;
    overflow: visible;
    box-sizing: border-box;
    border-radius: 0px;
    text-decoration: none solid rgb(102, 102, 102);
    list-style: outside none none;
    text-align: center;
}
.headList>li>div>dl>dt>a:hover{
    color: #ffffff;
    background-color: rgb(0, 160, 234);
}
.hd{
  display: flex;
  /* justify-content: center; */
}
.banner{
display: flex;
justify-content: center;
}
</style>
